var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppletv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "51.3 212.3 497.3 175.3",
    enableBackground: "new 51.3 212.3 497.3 175.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "family-chapternav-tv-02-lily-COlily") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.7,240.8c6.5-8,9.6-18.2,8.7-28.4c-10,1-19.3,5.8-25.9,13.4c-6.6,7.4-10,17.1-9.3,27 C132.3,253.2,142.2,248.7,148.7,240.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,240.1c6.3-7.8,9.4-17.8,8.7-27.8c-10,1-19.3,5.8-25.9,13.4c-6.6,7.4-10,17.1-9.3,27 C132.5,253,142.3,248.3,148.7,240.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2,254.4c-14.4-0.9-26.7,8.2-33.3,8.2s-17.4-7.8-28.9-7.6c-15.2,0.4-29,8.9-36.2,22.2C43.2,304,54.7,344,69.9,365.4 c7.3,11.1,16.1,22.2,27.8,22.2s15.3-7.1,28.7-7.1s17.2,7.1,28.9,6.9c11.7-0.2,19.6-11.1,26.9-21.6c5.2-7.6,9.2-16,12-24.8 c-14.2-6.3-23.3-20.4-23.2-35.9c0.2-13.6,7.4-26.2,19-33.3c-7.4-10.5-19.3-17-32.1-17.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,240.2v27.7h22.2V287h-22.2v65c0,10.1,4.4,14.8,14.3,14.8c2.7,0,5.3-0.2,8-0.6v19c-4.4,0.8-8.9,1.2-13.4,1.1 c-23.9,0-33.3-9-33.3-31.8v-67.2h-16.8v-19.4h17.1v-27.7H270.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,386h-25.8L306,267.9h25.8l29.6,94.2l0,0l30-94.2h25.3L374.4,386z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "548.7,315.2 501.7,315.2 501.7,268.1 479.3,268.1 479.3,315.2 432.5,315.2 432.5,337.3 479.3,337.3 479.3,384.7  501.7,384.7 501.7,337.3 548.7,337.3  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppletv);
export default __webpack_public_path__ + "static/media/appletv.3b75e42b4781dd3b3546106fabb53ac1.svg";
export { ForwardRef as ReactComponent };